/* eslint-disable no-console, no-case-declarations, no-unused-vars */
import { graphqlClient } from "@/utils/http";
import * as request from "@/data/graphql/personal-profile/teacher-profile-graphql.js";

export const getTeachers = async () => { 
  const query = request.getTeachers();
  return await graphqlClient(query);
};
